import { LOGOUT } from '../../../store/Types';

export const ALL_PAISES = 'ALL_PAISES';
export const ACTIVO_PAISES = 'ACTIVO_PAISES';
export const ALERT_VIEW_PAISES = 'ALERT_VIEW_PAISES';
export const LOADING_ALL_PAISES = 'LOADING_ALL_PAISES';
export const PARAMS_PAISES = 'PARAMS_PAISES';
export const SEARCH_PAISES = 'SEARCH_PAISES';

const initialState = {
  all: [],
};

export const paisesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PAISES:
      return {
        ...state,
        all: action.payload.data,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
